import { useEffect, useMemo, useState } from "react";

const CART_KEY = "rsi_app_cart";

export default function useAppCart() {
  const [items, setItems] = useState(() => {
    if (typeof localStorage === "undefined") return [];
    try {
      const raw = localStorage.getItem(CART_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(CART_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, quantity = 1) => {
    setItems((current) => {
      const existing = current.find((item) => item.product_id === product.id);
      if (existing) {
        return current.map((item) =>
          item.product_id === product.id
            ? { ...item, quantity: Math.max(1, item.quantity + quantity) }
            : item
        );
      }
      return [
        ...current,
        {
          product_id: product.id,
          product_slug: product.slug,
          product_name: product.name,
          image_url: product.image_url,
          category_slug: product.category_slug,
          price_label: product.price_range || "",
          moq_label: product.moq || "",
          quantity: Math.max(1, quantity),
        },
      ];
    });
  };

  const updateQuantity = (productId, quantity) => {
    const nextQty = Math.max(1, quantity);
    setItems((current) =>
      current.map((item) =>
        item.product_id === productId ? { ...item, quantity: nextQty } : item
      )
    );
  };

  const removeItem = (productId) => {
    setItems((current) => current.filter((item) => item.product_id !== productId));
  };

  const clearCart = () => setItems([]);

  const summary = useMemo(
    () => ({
      lineItems: items.length,
      totalUnits: items.reduce((sum, item) => sum + Number(item.quantity || 0), 0),
    }),
    [items]
  );

  return {
    items,
    setItems,
    addItem,
    updateQuantity,
    removeItem,
    clearCart,
    lineItems: summary.lineItems,
    totalUnits: summary.totalUnits,
  };
}
